/**
 * "All caught up" / "nothing set up yet" state for the Today view
 * (today-view.md SS3, spec AC-9/AC-17; extended by phase-2b-habits.md
 * AC-B20 to invite habit creation too, now that habits are a first-class
 * daily-page citizen — not just an objective-only CTA). Rendered when
 * getDailyPage returns zero dueActions AND zero habits with nothing to
 * feature (today-view.md v2.2's "nothing at all" state).
 */
export function EmptyToday({
  onCreateObjective,
  onCreateHabit,
}: {
  readonly onCreateObjective: () => void;
  readonly onCreateHabit: () => void;
}) {
  return (
    <div
      style={{
        padding: 'var(--space-10) var(--layout-page-margin-phone)',
        textAlign: 'center',
      }}
    >
      <p
        style={{
          fontSize: 'var(--type-body-size)',
          lineHeight: 'var(--type-body-line)',
          color: 'var(--text-secondary)',
          margin: 0,
        }}
      >
        Nothing due today. Add an action to an objective, or set up a habit, to see it here.
      </p>
      <div
        style={{
          display: 'flex',
          gap: 'var(--space-3)',
          justifyContent: 'center',
          marginTop: 'var(--space-5)',
        }}
      >
        <button
          type="button"
          onClick={onCreateObjective}
          style={{
            padding: 'var(--space-3) var(--space-5)',
            borderRadius: 'var(--radius-md)',
            // Vivid tier, not text-safe: a button background is a fill/shape,
            // not text (tokens.md "Two tiers, one rule" — button fills use
            // hue.primary.vivid, same as CheckControl/ProgressRing elsewhere).
            background: 'var(--hue-primary-vivid)',
            color: 'var(--text-on-accent)',
            fontWeight: 600,
            fontSize: 'var(--type-body-size)',
            minHeight: 'var(--touch-target-min)',
          }}
        >
          Create an objective
        </button>
        <button
          type="button"
          onClick={onCreateHabit}
          style={{
            padding: 'var(--space-3) var(--space-5)',
            borderRadius: 'var(--radius-md)',
            background: 'transparent',
            border: '1px solid var(--border-strong)',
            color: 'var(--text-secondary)',
            fontWeight: 600,
            fontSize: 'var(--type-body-size)',
            minHeight: 'var(--touch-target-min)',
          }}
        >
          Set up a habit
        </button>
      </div>
    </div>
  );
}
